import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetActivitiesForStageById = createAsyncThunk(
  "GetActivitiesForStageById/GetActivitiesForStageById",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ActivitiesForStage/GetActivitiesForStageById",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteActivitiesForStage = createAsyncThunk(
  "DeleteActivitiesForStage/DeleteActivitiesForStage",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ActivitiesForStage/DeleteActivitiesForStage",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateActivitiesForStage = createAsyncThunk(
  "UpdateActivitiesForStage/UpdateActivitiesForStage",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ActivitiesForStage/UpdateActivitiesForStage",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AddActivitiesForStage = createAsyncThunk(
  "AddActivitiesForStage/AddActivitiesForStage",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ActivitiesForStage/AddActivitiesForStage",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateActivitiesForStage = createAsyncThunk(
  "ValidateActivitiesForStage/ValidateActivitiesForStage",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ActivitiesForStage/ValidateActivitesForStage",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ActivitiesForStage = createSlice({
  name: "ActivitiesForStage",
  initialState: {
    ActivitiesForStage: {},
    loadingActivitiesForStage: false,
    errorActivitiesForStage: null,

    AddActivitiesForStage: {},
    loadingAddActivitiesForStage: false,
    errorAddActivitiesForStage: null,

    UpdateActivitiesForStage: {},
    loadingUpdateActivitiesForStage: false,
    errorUpdateActivitiesForStage: null,

    DeleteActivitiesForStage: {},
    loadingDeleteActivitiesForStage: false,
    errorDeleteActivitiesForStage: null,

    ActivitiesForStageValidate: [],
    loadingActivitiesForStageValidate: false,
    errorActivitiesForStageValidate: null,
  },
  reducers: {
    restValidateActivitiesForStage: (state, action) => {
      state.ActivitiesForStageValidate = [];
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(GetActivitiesForStageById.pending, (state, action) => {
        state.loadingActivitiesForStage = true;
        state.ActivitiesForStage = action.payload;
        state.errorActivitiesForStage = null;
      })
      .addCase(GetActivitiesForStageById.fulfilled, (state, action) => {
        state.loadingActivitiesForStage = false;
        state.ActivitiesForStage = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetActivitiesForStageById.rejected, (state, action) => {
        state.loadingActivitiesForStage = false;
        state.errorActivitiesForStage = action.payload;
      })

      .addCase(DeleteActivitiesForStage.pending, (state, action) => {
        state.loadingDeleteActivitiesForStage = true;
        state.DeleteActivitiesForStage = action.payload;
        state.errorDeleteActivitiesForStage = null;
      })
      .addCase(DeleteActivitiesForStage.fulfilled, (state, action) => {
        state.loadingDeleteActivitiesForStage = false;
        state.DeleteActivitiesForStage = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteActivitiesForStage.rejected, (state, action) => {
        state.loadingDeleteActivitiesForStage = false;
        state.errorDeleteActivitiesForStage = action.payload;
      })

      .addCase(UpdateActivitiesForStage.pending, (state, action) => {
        state.loadingUpdateActivitiesForStage = true;
        state.UpdateActivitiesForStage = action.payload;
        state.errorUpdateActivitiesForStage = null;
      })
      .addCase(UpdateActivitiesForStage.fulfilled, (state, action) => {
        state.loadingUpdateActivitiesForStage = false;
        state.UpdateActivitiesForStage = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateActivitiesForStage.rejected, (state, action) => {
        state.loadingUpdateActivitiesForStage = false;
        state.errorUpdateActivitiesForStage = action.payload;
      })

      .addCase(AddActivitiesForStage.pending, (state, action) => {
        state.loadingAddActivitiesForStage = true;
        state.AddActivitiesForStage = action.payload;
        state.errorAddActivitiesForStage = null;
      })
      .addCase(AddActivitiesForStage.fulfilled, (state, action) => {
        state.loadingAddActivitiesForStage = false;
        state.ActivitiesForStage = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddActivitiesForStage.rejected, (state, action) => {
        state.loadingAddActivitiesForStage = false;
        state.errorAddActivitiesForStage = action.payload;
      })
      .addCase(ValidateActivitiesForStage.pending, (state, action) => {
        state.loadingActivitiesForStageValidate = true;
        state.ActivitiesForStageValidate = action.payload;
        state.errorActivitiesForStageValidate = null;
      })
      .addCase(ValidateActivitiesForStage.fulfilled, (state, action) => {
        state.loadingActivitiesForStageValidate = false;
        state.ActivitiesForStageValidate = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidateActivitiesForStage.rejected, (state, action) => {
        state.loadingActivitiesForStageValidate = false;
        state.errorActivitiesForStageValidate = action.payload;
      });
  },
});
export const { restValidateActivitiesForStage } = ActivitiesForStage.actions;
export default ActivitiesForStage.reducer;
